import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;


const ImageLanguage = props => {
	const handleSelect = (e) => {
		const targetValue = e.target.value
		if (targetValue === 'false') {
			props.changesHandler({imageLanguage: false})
			return
		}
		props.changesHandler({imageLanguage: targetValue})
	}
	const { t } = props;
	return (
		<Container>
			<Label>{t('controls/image/language/label')}</Label>
			<StyledSelect
				id="image-language"
				style={{ width: '100%' }}
				options={[
					{ value: 'false', name: t('controls/image/language/all') },
					{ value: 'fi', name: 'fi' },
					{ value: 'en', name: 'en' },
				]}
				value={props.imageLanguage}
				onChange={handleSelect}
			/>
		</Container>
	)
}

ImageLanguage.propTypes = {
	t: PropTypes.func,
	imageLanguage: PropTypes.oneOf([false, 'fi', 'en']),
	size: PropTypes.oneOf(['cover', 'contain']),
	changesHandler: PropTypes.func,
}

export default translate('translations')(ImageLanguage)
